export default __webpack_public_path__ + "static/media/warning--double-turn-first-right--g1.98471837.png";